import React from "react"
import { EDIT_TYPE } from "../../../../../../../../types"
import { Buttons } from "../../components/buttons"
import BaseDraftEditor from "../../abstract/base-draft-editor"
import {
  CustomStyleEditor,
  EditorWrapper,
} from "../../components/custom-style-editor"
import { ToolBarWithoutWeight } from "../../components/tool-bar"
import styled from "styled-components"
import { ChatFontStyle } from "../../../../../../../../../../components/templates/chat/components/styles/chat-font-style"
import { container } from "../container"

class Component extends BaseDraftEditor {
  public render() {
    if (this.props.content._editMetaData.type === EDIT_TYPE.MENU) {
      return (
        <StyledEditorWrapper onClick={this.editMode}>
          <CustomStyleEditor
            editorState={this.state.editorState}
            onChange={this.onChange}
          />
        </StyledEditorWrapper>
      )
    }

    return (
      <>
        <ToolBarWithoutWeight
          onChange={this.onChange}
          editorState={this.state.editorState}
        />
        <StyledEditorWrapper>
          <CustomStyleEditor
            editorState={this.state.editorState}
            onChange={this.onChange}
          />
        </StyledEditorWrapper>
        <Buttons save={this.save} cancel={this.cancel} />
      </>
    )
  }
}

export const AnnotationEditor = container(Component)

const StyledEditorWrapper = styled(EditorWrapper)`
  ${ChatFontStyle.ANNOTATION};
`
